import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PracticeAreaCard = ({ area }) => {
  const Icon = area.icon;
  const isGold = area.color === 'gold';

  return (
    <div className={`bg-white rounded-2xl overflow-hidden shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 group`}>
      <div className={`h-2 ${isGold ? 'bg-gold' : 'bg-primary-blue'}`}></div>
      <div className="p-8">
        <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 ${
          isGold ? 'bg-gold bg-opacity-10' : 'bg-primary-blue bg-opacity-10'
        } group-hover:scale-110 transition-transform duration-300`}>
          <Icon className={`w-8 h-8 ${isGold ? 'text-gold' : 'text-primary-blue'}`} />
        </div>
        <h3 className={`text-2xl font-bold mb-4 ${isGold ? 'text-primary-blue' : 'text-primary-blue'}`}>
          {area.title}
        </h3>
        <p className="text-dark-gray mb-6 leading-relaxed">
          {area.description}
        </p>
        <Link
          to={area.link}  
          className={`inline-flex items-center font-semibold group-hover:translate-x-1 transition-transform ${
            isGold ? 'text-gold hover:text-dark-gold' : 'text-primary-blue hover:text-secondary-blue'
          }`}
        >
          Learn More
          <ArrowRight className="w-4 h-4 ml-1" />
        </Link>
      </div>
    </div>
  );
};

export default PracticeAreaCard;